import { ListingType } from '@domain-group/fe-allhomes-library/lib/node';
import { DefaultSearchType, parseSearchType } from '../enums/search-type';
var getListingTypeKey = input => {
  if (typeof input === 'string') {
    return input;
  }
  if ('name' in input) {
    return input.name;
  }
  var listingType = input.listingType;
  return ListingType[listingType].name || 'SALES_RESIDENTIAL';
};
export var parseSearchOptions = input => {
  var listingType = getListingTypeKey(input);
  var searchType = typeof input === 'object' && 'searchType' in input ? input.searchType : DefaultSearchType;
  return {
    listingType,
    searchType: parseSearchType(searchType)
  };
};